import { useMemo, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import ban from '~/assets/icons/ban.svg';
import call from '~/assets/icons/call.svg';
import dots from '~/assets/icons/dots.svg';
import message from '~/assets/icons/message.svg';
import plusRound from '~/assets/icons/plus_round.svg';
import { playSound, Sound } from '~/assets/sounds';
import { DropdownMenu, IDropdownMenuItem } from '../DropdownMenu';
import { TextLabel } from '../TextLabel';
import {
	StyledButtonsContainer,
	StyledContainer,
	StyledDropdownWrapper,
	StyledImage,
	StyledImageButton,
	StyledLeftContainer,
	StyledNameOnlineContainer,
} from './AppMessagePlayerCard.styled';

const AppMessagePlayerCard = ({
	nickname,
	online,
	favorite,
	index,
	bottom,
}: {
	nickname: string;
	online?: boolean;
	favorite?: boolean;
	index: number;
	bottom?: boolean;
}) => {
	const [dropdownVisible, setDropdownVisible] = useState(false);

	const dropDownMenuItems: IDropdownMenuItem[] = useMemo(
		() => [
			{
				title: 'Позвонить',
				icon: call,
				onClick: () => console.log('--call', nickname),
			},
			{
				title: 'Добавить в друзья',
				icon: plusRound,
				onClick: () => console.log('--add', nickname),
			},
			{
				title: 'Заблокировать',
				icon: ban,
				onClick: () => console.log('--ban', nickname),
			},
		],
		[nickname],
	);

	return (
		<StyledContainer $online={online} $favorite={favorite}>
			<StyledLeftContainer>
				<StyledImage $online={online} />
				<StyledNameOnlineContainer $online={online}>
					<TextLabel className={'name'}>{nickname}</TextLabel>
					<TextLabel className={'online'}>
						{online ? 'Онлайн' : 'Не в сети'}
					</TextLabel>
				</StyledNameOnlineContainer>
			</StyledLeftContainer>
			<StyledButtonsContainer>
				<StyledImageButton
					src={message}
					width={20}
					height={20}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
					onClick={() => {
						playSound(Sound.ClickButton);
					}}
				/>
				<StyledImageButton
					src={dots}
					width={20}
					height={20}
					onClick={() => {
						setDropdownVisible(true);
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
			</StyledButtonsContainer>
			<CSSTransition
				in={dropdownVisible}
				timeout={300}
				classNames={'menu'}
				unmountOnExit
			>
				<StyledDropdownWrapper $right={index % 3 === 2} $bottom={bottom}>
					<DropdownMenu
						items={dropDownMenuItems}
						closeHandler={() => {
							setDropdownVisible(false);
							playSound(Sound.ClickButton);
						}}
					/>
				</StyledDropdownWrapper>
			</CSSTransition>
		</StyledContainer>
	);
};

export { AppMessagePlayerCard };
